import { TextField } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import ArchiveIcon from "@material-ui/icons/Archive";
import AssignmentIcon from "@material-ui/icons/Assignment";
import Build from "@material-ui/icons/Build";
import Business from "@material-ui/icons/Business";
import DevicesOther from "@material-ui/icons/DevicesOther";
import DirectionsBoatIcon from "@material-ui/icons/DirectionsBoat";
import DonutSmallIcon from "@material-ui/icons/DonutSmall";
import Equalizer from "@material-ui/icons/Equalizer";
import GavelIcon from "@material-ui/icons/Gavel";
import Receipt from "@material-ui/icons/Receipt";
import RoomServiceIcon from "@material-ui/icons/RoomService";
import Settings from "@material-ui/icons/Settings";
import Store from "@material-ui/icons/Store";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import BadgeLink from "../../Components/BadgeLink";
import { getUser, USER_GROUPS } from "../../Utils/Common";
// import EnvSettings from "../../Utils/EnvSettings";

// const server = EnvSettings.server;

/**
 *
 * Moduuli softalle --> julkaisut, asennuksien lukumäärät ja kaatumiset
 * Moduuli laitteille --> ajot ja niiden tilastot == Dashboard
 * Moduuli siirroille --> uusimmat siirrot
 * Moduuli huollolle --> uusimmat tiketit ja huomautukset
 * Moduuli asiakkaille
 *
 * @param {*} props
 * @returns
 */

export default function ControlPanel(props) {
  const { t } = useTranslation();
  const [search, setSearch] = useState();
  const badgeLinks = [
    {
      href: "/cpanel/tasks",
      title: t("tasks.header"),
      icon: AssignmentIcon,
    },
    {
      href: "/cpanel/software",
      title: t("software.header"),
      icon: ArchiveIcon,
      superuser: true,
    },
    {
      href: "/cpanel/devices/dashboard",
      title: t("devices.header"),
      icon: DevicesOther,
    },
    {
      href: "/cpanel/production",
      title: t("lifeCycleManagement.header"),
      icon: DonutSmallIcon,
    },
    {
      href: "/cpanel/maintenance",
      title: t("maintenance.header"),
      icon: Build,
    },
    {
      href: "/cpanel/manufacturing",
      title: t("manufacturing.header"),
      icon: GavelIcon,
    },
    {
      href: "/cpanel/serviceitems",
      title: t("serviceItemsModule.header"),
      icon: RoomServiceIcon,
    },
    {
      href: "/cpanel/contacts",
      title: t("contacts.header"),
      icon: Business,
    },
    {
      href: "/cpanel/system",
      title: t("system.header"),
      icon: Settings,
      superuser: true,
    },
    {
      href: "/cpanel/stock",
      title: t("stock.header"),
      icon: Equalizer,
    },
    {
      href: "/cpanel/orders",
      title: t("orders.header"),
      icon: Receipt,
    },
    {
      href: "/cpanel/resupply",
      title: t("resupplyOrders.header"),
      icon: AddShoppingCartIcon,
    },
    {
      href: "/cpanel/webstore",
      title: t("webstoreOrders.header"),
      icon: Store,
    },
    {
      href: "/cpanel/shipments",
      title: t("shipments.header"),
      icon: DirectionsBoatIcon,
    },
  ];

  return (
    <Grid container justify="center">
      <Grid container spacing={3} justify="center" item md={12} lg={6}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            label={t("search")}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></TextField>
        </Grid>
        {/* All the admin items as badges */}
        {badgeLinks
          .filter(
            (a) =>
              !search ||
              (search && a.title.toLowerCase().includes(search.toLowerCase()))
          )
          .sort((a, b) => {
            return a.title > b.title ? 1 : -1;
          })
          .map((b, i) =>
            b.superuser &&
            getUser().permissionlevel !== USER_GROUPS.SUPER_USER ? null : (
              <BadgeLink key={i} href={b.href} title={b.title} icon={b.icon} />
            )
          )}
      </Grid>
    </Grid>
  );
}
